var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"touch",class:{swiped: _vm.swiped, up: _vm.swiped == 'up', right: _vm.swiped == 'right', down: _vm.swiped == 'down', left: _vm.swiped == 'left'}},[_vm._t("default",null,{"swiped":_vm.swiped,"x":_vm.x,"y":_vm.y})],2)}
var staticRenderFns = []

export { render, staticRenderFns }